function InitialiseSlickSection()
{
    var goalSettings = 
    {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        buttons: false,
        responsive: 
        [
            {
                breakpoint: 768, 
                settings: 
                {
                    slidesToShow: 1.50,
                    slidesToScroll: 1
                }
            }
        ]        
    }

    var standardSetting = 
    {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        buttons: false,
        responsive: 
        [
            {
                breakpoint: 480, 
                settings: 
                {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    }

    if( document.querySelector( ".slick-target" ) )
    {
        $('.slick-target').each(function(index, element) 
        {
            var slider = $(this); 
            if( slider[0].classList.contains( "slick-target-goal" ) )
            {
                console.log( element );
                slider.slick( goalSettings );                
            }
            else
            {
                slider.slick( standardSetting );
            }

        });
    } 
}

function unslickSection()
{
    if( document.querySelector( ".slick-target" ) )
    {
        $('.slick-target').each(function(index, element) 
        {
            var slider = $(this);
            slider.slick( 'unslick' );
        });
    }
} 

function responsiveScreenSize( screenSize ) 
{
    if ( screenSize.matches ) 
    {
        InitialiseSlickSection( );
    }
    else 
    {
        unslickSection( );
    }
}

var screenSize      = window.matchMedia("(max-width: 767px)")
responsiveScreenSize( screenSize );
screenSize.addListener( responsiveScreenSize );
